import { useEffect, useState } from 'react';
import axios from 'axios';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Beim Prerendering (SSG) werden die Daten als window.__PROVIDER_SETTINGS__ eingebettet
let cache = globalThis.__PROVIDER_SETTINGS__ || null;
let pending = null;

const load = () => {
  pending = pending || axios
    .get(`${API_URL}/public/provider-settings`)
    .then((res) => (cache = res.data))
    .catch(() => cache);
  return pending;
};

export const refreshProviderSettings = () => {
  pending = null;
  return load();
};

export function useProviderSettings() {
  const [settings, setSettings] = useState(() => cache || globalThis.__PROVIDER_SETTINGS__ || null);
  useEffect(() => {
    let active = true;
    load().then((data) => active && data && setSettings(data));
    return () => { active = false; };
  }, []);
  return settings;
}

export const formatBookableFrom = (dateStr, withYear = false) => {
  if (!dateStr) return '';
  const [y, m, d] = dateStr.split('-').map(Number);
  return new Date(Date.UTC(y, m - 1, d)).toLocaleDateString('de-DE', {
    weekday: 'long', day: 'numeric', month: 'long', ...(withYear ? { year: 'numeric' } : {}), timeZone: 'UTC',
  });
};

export const isBeforeBookable = (dateStr, bookableFrom) => Boolean(bookableFrom && dateStr && dateStr < bookableFrom);

export const getWhoAdvisesFaq = (settings) => ({
  q: 'Wer führt die Beratung durch?',
  a: `Die Beratung führt eine examinierte Pflegefachkraft unseres Partners ${settings?.company_name || 'einem zugelassenen Pflegedienst'}, einem zugelassenen ambulanten Pflegedienst, durch. Die Abrechnung erfolgt direkt mit Ihrer Pflegekasse – für Sie kostenlos.`,
});
